import React, { useState } from 'react';
import { Alert, Box, Tab, Tabs, Typography } from '@mui/material';
import { Link as RouterLink, useSearchParams } from 'react-router-dom';
import SearchableSelect from '../common/SearchableSelect';
import { usePayrollInstitution } from '../../hooks/usePayrollInstitution';
import { usePermission } from '../../hooks/usePermission';
import { PERMISSIONS } from '../../constants/permissions';
import PfMembersTab from './PfMembersTab';
import PfRunsTab from './PfRunsTab';
import PfProfitTab from './PfProfitTab';
import PfSettingsTab from './PfSettingsTab';

// W3-J: provident fund (HR side): members and ledger, monthly contribution runs, annual profit allocation, settings.
const ProvidentFund: React.FC = () => {
    const canManage = usePermission(PERMISSIONS.PAYROLL_MANAGE);
    const { isSystemAdmin, institutions, institutionId, setInstitutionId } = usePayrollInstitution();
    // ?tab=runs (the contribution-run reminder) opens on Contribution runs.
    const [tab, setTab] = useState(useSearchParams()[0].get('tab') === 'runs' ? 1 : 0);

    return (
        <Box sx={{ p: { xs: 1.5, sm: 3 } }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 1, mb: 1 }}>
                <Typography variant="h5">Provident Fund</Typography>
                {isSystemAdmin && (
                    <SearchableSelect
                        data-help="payroll.pfPage.institution" label="Select Institution" options={institutions} value={institutionId}
                        onChange={id => setInstitutionId(id)} getOptionLabel={i => i.name} clearable={false}
                        sx={{ flex: '1 1 220px', maxWidth: 320 }}
                    />
                )}
            </Box>
            <Alert severity="info" sx={{ mb: 2 }}>
                Provident fund accounts are configured under Payroll &gt; <RouterLink to="/payroll/provisions">Provisions</RouterLink> &gt; Accounts.
            </Alert>

            <Tabs value={tab} onChange={(_, v) => setTab(v)} variant="scrollable" scrollButtons="auto" sx={{ mb: 2 }}>
                <Tab label="Members" />
                <Tab label="Contribution runs" />
                <Tab label="Profit allocation" />
                <Tab label="Settings" />
            </Tabs>

            {tab === 0 && <PfMembersTab institutionId={institutionId} canManage={canManage} />}
            {tab === 1 && <PfRunsTab institutionId={institutionId} canManage={canManage} />}
            {tab === 2 && <PfProfitTab institutionId={institutionId} canManage={canManage} />}
            {tab === 3 && <PfSettingsTab institutionId={institutionId} canManage={canManage} />}
        </Box>
    );
};

export default ProvidentFund;
